import { Row } from 'antd'

import { FullPageSpinner, FullPageSpinnerProps } from './FullPageSpinner'

type LoadingSpinnerProps = FullPageSpinnerProps
export function LoadingSpinner({ loading, ...rest }: LoadingSpinnerProps) {
  return (
    <Row justify="space-between">
      <FullPageSpinner {...rest} loading={loading} />
    </Row>
  )
}
